module.exports = __webpack_public_path__ + "img/恢复.a47de83f.svg";